import { render, staticRenderFns } from "./CommunityFamilyList.vue?vue&type=template&id=23d26505&scoped=true&"
import script from "./CommunityFamilyList.vue?vue&type=script&lang=js&"
export * from "./CommunityFamilyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d26505",
  null
  
)

export default component.exports